import { render, staticRenderFns } from "./ordersTrajectory.vue?vue&type=template&id=1efc2d72&scoped=true&"
import script from "./ordersTrajectory.vue?vue&type=script&lang=js&"
export * from "./ordersTrajectory.vue?vue&type=script&lang=js&"
import style0 from "./ordersTrajectory.vue?vue&type=style&index=0&id=1efc2d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc2d72",
  null
  
)

export default component.exports